var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyFundingDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8626 20.7318C18.8626 21.512 18.2759 22.1445 17.5521 22.1445H1.82612C1.10235 22.1445 0.515625 21.512 0.515625 20.7318V2.36589C0.515625 1.58564 1.10235 0.953125 1.82612 0.953125H13.0173C13.3594 0.952916 13.688 1.09691 13.9329 1.35435L18.4668 5.63217C18.7198 5.89805 18.8626 6.2628 18.8626 6.64371V20.7318Z",
    stroke: "#51546B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48633 8.0166H14.9703",
    stroke: "#51546B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48633 12.2549H14.9703",
    stroke: "#51546B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48633 16.4932H9.72832",
    stroke: "#51546B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyFundingDoc);
export default __webpack_public_path__ + "static/media/GreyFundingDoc.326302e56d466c48462dbb0257888c5a.svg";
export { ForwardRef as ReactComponent };